import Home from '../components/pages/Home.vue';

export default [
    {
        path: '/',
        component: Home,
        name: 'home'
    },
]
